import { EskTypeT, SponsorT } from "types/sponsor"

export const DefaultEskSponsor: SponsorT = "swi"
export const DefaultEskType: EskTypeT = "HOST"

export const UNKNOWN_VERSION = "Unknown"

export const PRIVACY_POLICY_URL = "https://sidekickplatform.com/privacy.html"
